import React, { useMemo } from 'react';
import moment from 'moment';
import { months as monthNames } from '../../../../../constants';

export default function MonthView({ 
  month, 
  availableDays, 
  selectedDate, 
  onSelectDay, 
  showNavigation = false,
  onPrevMonth,
  onNextMonth,
  canGoPrev = true,
  canGoNext = true
}) {
  const today = moment().startOf('day');
  
  // Generate array of weeks for the month
  const calendar = useMemo(() => {
    const firstDay = moment(month).startOf('month');
    const lastDay = moment(month).endOf('month');
    
    // Get the first day of the ISO week (Monday) containing the first day of the month
    const startDate = moment(firstDay).startOf('isoWeek');
    // Get the last day of the ISO week (Sunday) containing the last day of the month
    const endDate = moment(lastDay).endOf('isoWeek');
    
    const days = [];
    let week = [];
    
    // Generate all days from start to end
    for (let day = moment(startDate); day.isSameOrBefore(endDate); day.add(1, 'day')) {
      week.push({
        date: day.format('YYYY-MM-DD'),
        dayOfMonth: day.date(),
        isCurrentMonth: day.month() === month.month(),
        isToday: day.isSame(today, 'day'),
        isAvailable: availableDays[day.format('YYYY-MM-DD')] !== undefined,
        isAbsent: availableDays[day.format('YYYY-MM-DD')] !== undefined && (availableDays[day.format('YYYY-MM-DD')].every(slot => slot.status === 'ABSENT' ) || availableDays[day.format('YYYY-MM-DD')].every(slot => slot.status !== 'FREE' )),
        is_booked_by_patient: availableDays[day.format('YYYY-MM-DD')] !== undefined && availableDays[day.format('YYYY-MM-DD')].find(slot => slot.status === 'RECORD' && slot?.is_booked_by_patient === true),
        isPast: day.isBefore(today),
      });
      
      if (week.length === 7) {
        days.push([...week]);
        week = [];
      }
    }
    
    return days;
  }, [month, availableDays, today]);

  const monthTitle = `${monthNames[month.format('MMMM')].full} ${month.year()}`;

  return (
    <div className="calendar-month">
      <div className="calendar-month-title">
        {showNavigation && (
          <div className="mobile-month-navigation">
            <button 
              className="month-nav-btn prev" 
              onClick={onPrevMonth}
              disabled={!canGoPrev}
            >
              <i className="fas fa-chevron-left"></i>
            </button>
            <span className="month-title-text">{monthTitle}</span>
            <button 
              className="month-nav-btn next" 
              onClick={onNextMonth}
              disabled={!canGoNext}
            >
              <i className="fas fa-chevron-right"></i>
            </button>
          </div>
        )}
        {!showNavigation && monthTitle}
      </div>
      <div className="calendar-month-weekdays">
        <div className="weekday">Пн</div>
        <div className="weekday">Вт</div>
        <div className="weekday">Ср</div>
        <div className="weekday">Чт</div>
        <div className="weekday">Пт</div>
        <div className="weekday">Сб</div>
        <div className="weekday">Нд</div>
      </div>
      <div className="calendar-month-days">
        {calendar.map((week, weekIndex) => (
          <div key={`week-${weekIndex}`} className="calendar-week">
            {week.map((day) => (
              <div 
                key={day.date} 
                className={`calendar-day ${!day.isCurrentMonth ? 'other-month' : ''} 
                  ${day.isToday ? 'today' : ''} 
                  ${day.isAvailable && !day.isPast ? 'available' : ''}
                  ${selectedDate === day.date ? 'selected' : ''}
                  ${day.isPast ? 'past' : ''}
                  ${day.isAbsent ? 'absent' : ''}
                  ${day.is_booked_by_patient ? 'booked_by_patient' : ''}
                  `}
                  
                onClick={() => {
                  if (day.isAvailable && !day.isPast) {
                    onSelectDay(day.date);
                  }
                }}
              >
                {day.dayOfMonth}
              </div>
            ))}
          </div>
        ))}
      </div>
      
      {showNavigation && (
        <style>{`
          .mobile-month-navigation {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 0.5rem;
          }
          
          .mobile-month-navigation .month-title-text {
            flex: 1;
            text-align: center;
            font-size: 1.1rem;
            font-weight: 600;
            color: #333;
          }
          
          .month-nav-btn {
            background: #1c5caa;
            color: white;
            border: none;
            width: 28px;
            height: 28px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.2s ease;
            font-size: 0.8rem;
          }
          
          .month-nav-btn:hover:not(:disabled) {
            background: #174a91;
            transform: scale(1.05);
          }
          
          .month-nav-btn:disabled {
            display: none;
          }
        `}</style>
      )}
    </div>
  );
}
